export default function triggerContactOverlay() {
  const isPresent = document.querySelector(".contact-overlay");
  if (!isPresent) {
    return;
  }

  const triggers = document.querySelectorAll("[data-contact-trigger]");
  const target = document.querySelector("[data-contact-target]");
  const close = document.querySelector("[data-contact-close]");

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", function () {
      target.classList.toggle("active");
    });
  });

  close.addEventListener("click", function () {
    target.classList.remove("active");
  });
}
